import { style } from '@vanilla-extract/css';

import { PRICING_ELEMENT_DEFAULT_INPUT_BORDER_RADIUS } from '@/constants';

export const pricingContainer = style({
  position: 'relative',
  margin: 'var(--margin)',
});

export const card = style({
  height: 'var(--card-height)',
  padding: 'var(--card-padding)',
  background: 'var(--card-background)',
  boxShadow: 'var(--card-shadow)',
});

export const tierName = style({
  color: 'var(--name-color)',
});

export const tierNameSelected = style({
  color: 'var(--name-selected-color)',
});

export const tierDescription = style({
  color: 'var(--description-color)',
});

export const tierDescriptionSelected = style({
  color: 'var(--description-selected-color)',
});

export const tierPrice = style({
  color: 'var(--price-color)',
  fontSize: 'var(--price-font-size)',
});

export const tierPriceDenominator = style({
  color: 'var(--price-denominator-color)',
  fontSize: 'var(--price-denominator-font-size)',
});

export const tierOfferPrice = style({
  color: 'var(--offer-price-color)',
  fontSize: 'var(--offer-price-font-size)',
});

export const tierFeatureIconColor = style({
  color: 'var(--feature-icon-color)',
});

export const tierFeatureIconColorSelected = style({
  color: 'var(--feature-selected-icon-color)',
});

export const tierFeatureTextColor = style({
  color: 'var(--feature-color)',
});

export const tierFeatureTextColorSelected = style({
  color: 'var(--feature-selected-color)',
});

export const tierOfferDetailsIconColor = style({
  color: 'var(--offer-details-icon-color)',
});

export const tierOfferDetailsTextColor = style({
  color: 'var(--offer-details-color)',
});

export const tierTabsContainerBorder = style({
  borderStyle: 'var(--tabs-container-border-style)',
  borderWidth: 'var(--tabs-container-border-width)',
  borderRadius: 'var(--tabs-container-border-radius)',
  borderColor: 'var(--tabs-container-border-color)',
});

export const tierTabBorder = style({
  borderStyle: 'var(--tab-border-style)',
  borderWidth: 'var(--tab-border-width)',
  borderRadius: 'var(--tab-border-radius)',
  borderColor: 'var(--tab-border-color)',
});

export const tierTabBackgroundColor = style({
  backgroundColor: 'var(--tab-background-color)',
});

export const tierTabSelectedBackgroundColor = style({
  backgroundColor: 'var(--tab-selected-background-color)',
});

export const tierTabTextColor = style({
  color: 'var(--tab-text-color)',
});

export const tierTabSelectedTextColor = style({
  color: 'var(--tab-selected-text-color)',
});

export const input = style({
  borderRadius: `var(--input-border-radius, ${PRICING_ELEMENT_DEFAULT_INPUT_BORDER_RADIUS}) !important`,
  borderWidth: 'var(--input-border-width, 1px) !important',
  borderColor: 'var(--input-border-color, #6b7280) !important',
  borderStyle: 'var(--input-border-style, solid) !important',
  backgroundColor: 'var(--input-background-color) !important',
  fontSize: 'var(--input-font-size)',
  color: 'var(--input-text-color)',
  selectors: {
    '&::placeholder': {
      color: 'var(--input-placeholder-color)',
    },
    '&::-webkit-datetime-edit-year-field': {
      color: 'var(--input-placeholder-color)',
    },
    '&::-webkit-datetime-edit-month-field': {
      color: 'var(--input-placeholder-color)',
    },
    '&::-webkit-datetime-edit-day-field': {
      color: 'var(--input-placeholder-color)',
    },
    '&::-webkit-calendar-picker-indicator': {
      filter: 'var(--input-calendar-icon-filter, none)',
    },
    '&:focus': {
      fontSize: 'var(--input-font-size)',
    },
  },
});

export const inputDateTime = style({
  selectors: {
    '&::-webkit-datetime-edit-text': {
      color: 'var(--input-placeholder-color)',
    },
  },
});

export const inputSubmit = style({
  fontSize: '14px',
  cursor: 'pointer',
  backgroundColor: 'var(--button-color)',
  color: 'var(--button-text-color)',
  borderStyle: 'var(--button-border-style)',
  borderWidth: 'var(--button-border-width)',
  borderColor: 'var(--button-border-color)',
  borderRadius: 'var(--button-border-radius)',
  whiteSpace: 'break-spaces',
  selectors: {
    '&:disabled': {
      backgroundColor: '#f1f1f1', // todo: pass this in node attrs
    },
  },
});

export const badge = style({
  backgroundColor: 'var(--recommended-background-color)',
  borderRadius: 'var(--recommended-border-radius)',
  color: 'var(--recommended-text-color)',
});

// Shared form styling (used by gift, group, and internal checkout forms).
// Falls back to the deprecated --gift-form-label-* vars so existing pricing nodes
// (saved before --form-label-* existed) keep rendering their customized color/size.
export const formLabel = style({
  width: '100%',
  textAlign: 'left',
  color: 'var(--form-label-text-color, var(--gift-form-label-text-color))',
  fontSize: 'var(--form-label-font-size, var(--gift-form-label-font-size))',
});

export const formHelper = style({
  textAlign: 'left',
  color: 'var(--form-helper-text-color, var(--form-label-text-color, var(--gift-form-label-text-color)))',
  fontSize: 'var(--form-helper-font-size, var(--form-label-font-size, var(--gift-form-label-font-size)))',
});

// Gift form
export const giftTabHeading = style({
  color: 'var(--gift-tab-heading-text-color)',
  fontSize: 'var(--gift-tab-heading-font-size)',
  textAlign: 'center',
});

export const giftFormHeading = style({
  color: 'var(--gift-form-heading-text-color)',
  fontSize: 'var(--gift-form-heading-font-size)',
});

// Group subscriptions form
export const groupSubsTabHeading = style({
  color: 'var(--group-subs-tab-heading-text-color)',
  fontSize: 'var(--group-subs-tab-heading-font-size)',
  textAlign: 'center',
});

export const groupSubsFormSummary = style({
  textAlign: 'left',
  color: 'var(--group-subs-form-summary-text-color, var(--form-label-text-color, var(--gift-form-label-text-color)))',
  fontSize: 'var(--group-subs-form-summary-font-size, var(--form-label-font-size, var(--gift-form-label-font-size)))',
});
